/* Updated theme JS sitewide 6-10-21 - currently using by Dev site. */

jQuery(document).ready(function (e) {
    var t = (function () {
        var t = function () {
                e(".grid-services .item").matchHeight(),
                    enquire.register("screen and (min-width: 992px)", {
                        match: function () {
                            e(".location-top-content .sameHeight").matchHeight(), e(".squares-grid .sameHeight").matchHeight();
                        },
                        unmatch: function () {},
                    }),
                    enquire.register("screen and (min-width: 768px)", {
                        match: function () {
                            e(".intro-content .sameHeight").matchHeight();
                        },
                        unmatch: function () {},
                    });
            },
            i = function () {
                e("ul#main-menu.desktop-nav li").hover(
                    function () {
                        e(this).addClass("hover");
                    },
                    function () {
                        e(this).removeClass("hover");
                    }
                ),
                    enquire.register("screen and (max-width: 767px)", {
                        match: function () {
                            e("ul.main-nav > li.dropdown > a").on("click", function (t) {
                                t.preventDefault(), e(this).next().slideToggle().toggleClass("open");
                            }),
                                e("ul.main-nav > li.dropdown > ul.dropdown-menu > li.dropdown > a").on("click", function (t) {
                                    t.preventDefault(), e(this).next().slideToggle().toggleClass("open");
                                });
                        },
                        unmatch: function () {},
                    });
            },
            n = function () {
                e(".contents-table").smoothScroll(),
                    e(".back-to-top-wrap").smoothScroll(),
                    e(".text-wrap").smoothScroll(),
                    e(".box-jumpto").smoothScroll(),
                    e(".info-details").smoothScroll(),
                    e(".text-right").smoothScroll(),
                    e(".text-center").smoothScroll();
            },
            o = function () {
                e(".footer-accordion-link").click(function (t) {

                    t.preventDefault(),
                        e(".footer-locations-list li").find("a").removeClass("active"),
                        e(this).addClass("active"),
                        e.ajax({
                            type: "POST",
                            url: cws.ajaxurl,
                            data: { action: "cws_map_link_ajax_callback", location_id: e(this).attr("data-id") },
                            dataType: "json",

                            success: function (t) {
                                if (t.success === !0) {
                                    var i = t.data.shortCode.split("#");
                                    e(".footer-location-details .address").html(i[0]),
                                        e(".footer-location-details .map-wrap img").attr("src", i[4]),
                                        (map = new google.maps.Map(document.getElementById("map-wrap-id"), { zoom: 15, center: { lat: parseFloat(i[1]), lng: parseFloat(i[2]) }, mapTypeId: "roadmap" }));
                                    var n;
                                    (n = new google.maps.Marker({ position: new google.maps.LatLng(parseFloat(i[1]), parseFloat(i[2])), map: map, icon: "/wp-content/themes/cws-theme-work/assets/images/custom-marker.png" })), n.setMap(map);
                                } else t.success === !1 && alert(t.data);
                            },
                        });
                });
            },
            s = function () {
                e(".featured-list-sidebar").slick({
                    slidesToShow: 1,
                    infinite: !0,
                    autoplay: !1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    speed: 300,
                    prevArrow: '<span class="icon-chevron-left"></span>',
                    nextArrow: '<span class="icon-chevron-right"></span>',
                    appendArrows: ".slick-nav-featured-sidebar",
                    dots: !1,
                }),
                e(".awards-list").slick({
                    slidesToShow: 5,
                    infinite: !0,
                    autoplay: !1,
                    slidesToScroll: 5,
                    initialSlide: 0,
                    speed: 300,
                    prevArrow: '<span class="icon-chevron-left"></span>',
                    nextArrow: '<span class="icon-chevron-right"></span>',
                    appendArrows: ".slick-nav-awards",
                    dots: !1,
                    variableWith: !0,
                    responsive: [
                        { breakpoint: 1199, settings: { dots: !1, infinite: !0, speed: 300, slidesToShow: 4, slidesToScroll: 4 } },
                        { breakpoint: 991, settings: { dots: !1, infinite: !0, speed: 300, slidesToShow: 3, slidesToScroll: 3 } },
                        { breakpoint: 767, settings: { dots: !1, infinite: !0, speed: 300, slidesToShow: 1, slidesToScroll: 1, centerMode: !0, variableWith: !1 } },
                    ],
                }),
                e(".meet-team .grid-team").slick({
                    slidesToShow: 1,
                    infinite: !0,
                    autoplay: !1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    speed: 300,
                    prevArrow: '<span class="icon-chevron-left"></span>',
                    nextArrow: '<span class="icon-chevron-right"></span>',
                    appendArrows: ".slick-nav-team",
                    dots: !1,
                    centerMode: !0,
                    variableWith: !1,
                    responsive: [
                        { breakpoint: 9999, settings: "unslick" },
                        { breakpoint: 767, settings: { dots: !1, infinite: !0, speed: 300, slidesToShow: 1, slidesToScroll: 1, centerMode: !0, variableWith: !1 } },
                    ],
                }),
                    enquire.register("screen and (max-width: 767px)", {
                        match: function () {
                            e(".intro-logos .grid-logos").slick({
                                slidesToShow: 1,
                                infinite: !0,
                                autoplay: !1,
                                slidesToScroll: 1,
                                initialSlide: 0,
                                speed: 300,
                                prevArrow: '<span class="icon-chevron-left"></span>',
                                nextArrow: '<span class="icon-chevron-right"></span>',
                                appendArrows: ".slick-nav-logos-sidebar",
                                dots: !1,
                                centerMode: !0,
                                variableWith: !1,
                            }),
                                e(".location-logos .grid-logos").slick({
                                    slidesToShow: 1,
                                    infinite: !0,
                                    autoplay: !1,
                                    slidesToScroll: 1,
                                    initialSlide: 0,
                                    speed: 300,
                                    prevArrow: '<span class="icon-chevron-left"></span>',
                                    nextArrow: '<span class="icon-chevron-right"></span>',
                                    appendArrows: ".slick-nav-logos-sidebar",
                                    dots: !1,
                                    centerMode: !0,
                                    variableWith: !1,
                                }),
                                e(".meet-team .grid-team").slick({
                                    slidesToShow: 1,
                                    infinite: !0,
                                    autoplay: !1,
                                    slidesToScroll: 1,
                                    initialSlide: 0,
                                    speed: 300,
                                    prevArrow: '<span class="icon-chevron-left"></span>',
                                    nextArrow: '<span class="icon-chevron-right"></span>',
                                    appendArrows: ".slick-nav-team",
                                    dots: !1,
                                    centerMode: !0,
                                    variableWith: !1,
                                }),
                                e(".awards-list").slick({
                                    slidesToShow: 1,
                                    infinite: !0,
                                    autoplay: !1,
                                    slidesToScroll: 1,
                                    initialSlide: 0,
                                    speed: 300,
                                    arrows: true,
                                    prevArrow: '<span class="icon-chevron-left"></span>',
                                    nextArrow: '<span class="icon-chevron-right"></span>',
                                    appendArrows: ".slick-nav-awards",
                                    dots: !1,
                                    centerMode: !0,
                                    variableWith: !1,
                                });
                        },
                        unmatch: function () {},
                    });
            },
            a = function () {
                e(".input-email").on("focus", function () {
                    "required" == e(this).parent().data("required") && e(this).parent().removeClass("required");
                }),
                    e(".input-email").on("blur", function () {
                        "" == e(this).val() && e(this).parent().addClass("required");
                    }),
                    e(".input-required").on("focus", function () {
                        "required" == e(this).parent().data("required") && e(this).parent().removeClass("required");
                    }),
                    e(".input-required").on("blur", function () {
                        "" == e(this).val() && e(this).parent().addClass("required");
                    });
            },
            r = function () {
                e(".credentials-accordion").on("click", ".panel-title a", function () {
                    ($link = e(".credentials-accordion .panel-title a")), e(this).hasClass("opened") ? e(this).removeClass("opened") : ($link.removeClass("opened"), e(this).addClass("opened"));
                }),
                    e(".practice-area-content .col-right ul li a span").each(function () {
                        e(this).outerHeight() > 25 && e(this).addClass("custom-arrow");
                    });
            },
            l = function () {
                e("#commentform").addClass("noauto").on("click", function (t) {
                        t.preventDefault(), e(this).stop().toggleClass("active"), e(this).parent().toggleClass("open");
                    });
            };

            //Accordion FAQs active state code
            anchors = document.querySelectorAll('.qa-faq-title, .qa-faq-anchor');

            if (anchors.length > 0) {
                window.addEventListener('click', (event) => {
                    if (event.target.matches('.qa-faq-anchor')) {
                        if (event.target.classList.contains('active')) {
                            event.target.classList.remove('active');
                            event.target.closest('.qa-faq-title').classList.remove('active');
                            return;
                        }
                        anchors.forEach(elem => {
                            if (elem.classList.contains('active')) {
                                elem.classList.remove('active');
                                event.target.closest('.qa-faq-title').classList.remove('active');
                            }
                        });
                        event.target.classList.add('active');
                        event.target.closest('.qa-faq-title').classList.add('active');
                    }
                }, true);
            }

        return {
            init: function () {
                n(), o(), s(), i(), t(), a(), r(), l();
            },
        };
    })();
    t.init();
});

jQuery(window).on("load resize orientationchange", function () {
    if (jQuery(window).width() > 768) {
        if (jQuery(".grid-logos").hasClass("slick-initialized")) {
            jQuery(".grid-logos").slick("unslick");
        }
    } 
    else if (jQuery(window).width() == 768) {
        if (!jQuery(".grid-logos").hasClass("slick-initialized")) {
            $(".grid-logos").slick({
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                prevArrow: '<span class="icon-chevron-left"></span>',
                nextArrow: '<span class="icon-chevron-right"></span>',
                appendArrows: ".slick-nav-logos-sidebar",
            });
        }
    }
    else {
        if (!jQuery(".grid-logos").hasClass("slick-initialized")) {
            $(".grid-logos").slick({
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<span class="icon-chevron-left"></span>',
                nextArrow: '<span class="icon-chevron-right"></span>',
                appendArrows: ".slick-nav-logos-sidebar",
            });
        }
    }
});
